import React, { useState, useEffect } from "react";
import AuthForm from "../components/signin_component";
import { postRequest } from "../functions/api_functions";
import { CssBaseline } from "@mui/material";
import { useAccessContext } from "../contexts/access_context";
import Main from "./main";
import AlertMessage from "../components/alert_component";

// Tipo de resposta da API
type LoginResponse = {
  access_id: number;
  status_code: number;
  school_cnpj: string;
};

interface ErrorState {
    type: "info" | "error" | "warning" | "success";
    message: string;
  }

const AdminPage: React.FC = () => {
  const { setAccess_data, access_data } = useAccessContext();
  const [error, setError] = useState<ErrorState | null>(null);

  // Função de autenticação
  const handleAuthenticate = async (email: string, password: string) => {
    setError(null); // Limpa erros anteriores
    try {
      const response = await postRequest<LoginResponse>("/validate_admin_access/", {
        body: { access_login: email, access_pws: password },
        headers: {},
      });

      if (response.status_code === 200) {
        // Atualiza o contexto com os dados retornados pela API
        setAccess_data((prevContext) => ({
          ...prevContext,
          school_cnpj: response.school_cnpj,
          students_re: 0,
          access_id: response.access_id,
          profile: 'school'
        }));
      } else {
        // Tratamento de erro específico para status code diferente de 200
        setError({ type: 'info', message: 'Falha na autenticação. Verifique suas credenciais.' });
      }
    } catch (err: unknown) {
      // Lida com erros específicos ou desconhecidos
      if (err instanceof Error) {
        setError({ type: 'info', message: 'Falha na autenticação. Verifique suas credenciais' });
      } else {
        setError({ type: 'error', message: 'Erro desconhecido. Tente novamente.' });
      }
    }
  };

  return (
    <>
      <CssBaseline />
        {access_data.access_id === 0 ? (
          <>
            {error && 
                (<AlertMessage key={Math.random()} message={error.message} type={error.type} auto_close={false} />)
            }
            <AuthForm onAuthenticate={handleAuthenticate} />
          </>
        ) : (
          <Main />
        )}
    </>
  );
};

export default AdminPage;
